const giftCards = () => {
  return '/gift-cards'
}

export default giftCards